import { render } from "./Value.vue?vue&type=template&id=6b7897aa&scoped=true"
import script from "./Value.vue?vue&type=script&lang=js"
export * from "./Value.vue?vue&type=script&lang=js"

import "./Value.vue?vue&type=style&index=0&id=6b7897aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7897aa"]])

export default __exports__